import { Stack } from '@mui/material';
import { FILTER_TYPES } from 'common/constants/filters';
import { StyledSectionTitle } from './CreateEditProjectModal.style';
import AzureBoardsTeamsAreasSelector from 'components/AzureBoardsTeamsAreasSelector';

const AreasSelector = ({ selectedFilters, setSelectedFilters }) => {
  return (
    <Stack spacing={0.5} marginBottom={3}>
      <StyledSectionTitle className='mandatory'>
        Project Scope
      </StyledSectionTitle>
      <AzureBoardsTeamsAreasSelector
        multipleEnabled
        defaultSelectedValues={
          selectedFilters?.[FILTER_TYPES.AZURE_BOARDS_PROJECT_TEAM_AREAS] || []
        }
        onChange={values =>
          setSelectedFilters(prev => ({
            ...prev,
            [FILTER_TYPES.AZURE_BOARDS_PROJECT_TEAM_AREAS]: values
          }))
        }
      />
    </Stack>
  );
};

export default AreasSelector;
